import { atom, selector } from 'recoil';
function stopAnyCurrentlyPlayingAudio() {
  for(const audio of document.querySelectorAll('audio')) {
      //audio.pause()
       audio.currentTime = 0;
       audio.play();
        // Do this to reset play head, simulate "stop"
  }
  }
// states: home -> intro -> main -> result
const gameProgressState = atom({
  key: 'gameProgress',
  default: 'home'
});

const tigerState = atom({
  key: 'tiger',
  default: {
    x: 40
  }
});

const gameState = atom({
  key: 'gameState',
  default: {
    life: new Set(),
    score: new Set()
  }
});

const replayState = selector({
  key: 'replay',
  set: ({ get, set }) => {
    const progress = get(gameProgressState)
    if (progress === 'result') {
      stopAnyCurrentlyPlayingAudio()
      set(gameProgressState, 'main')
      set(gameState, {
        life: new Set(),
        score: new Set()
      })
    } else {
      console.warn('incorrect state transition')
    }
  }
})

const restartState = selector({
  key: 'restart',
  set: ({ get, set }) => {
    const progress = get(gameProgressState)
    if (progress === 'result') {
      stopAnyCurrentlyPlayingAudio()
      set(gameProgressState, 'home')
      set(gameState, {
        life: new Set(),
        score: new Set()
      })
    } else {
      console.warn('incorrect state transition')
    }
  }
})

export {
  gameProgressState,
  replayState,
  restartState,
  tigerState,
  gameState
}
